import React, { Component, PureComponent } from 'react';
import Select from 'react-select';


//export default function SelectorDropdown() {
export default class SelectorDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    selectedOption: null
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    this.props.callbackFromParent(selectedOption);
  }

  render() {
    const { selectedOption } = this.state;
       return (
      <>
        <style jsx> {'.selector_Style {position: fixed; top:70px; left:100px; width: 400px; height:50px; z-index:3;}'} </style>

        <div className="selector_Style">
          <Select
            value={selectedOption}
            onChange={this.handleChange}
            options={this.props.selector_Options}
             />
           </div>



         
</>
    );
  }
}
